/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class StableCoin__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(owner, overrides) {
        return super.getDeployTransaction(owner, overrides || {});
    }
    deploy(owner, overrides) {
        return super.deploy(owner, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
StableCoin__factory.bytecode = _bytecode;
StableCoin__factory.abi = _abi;
//# sourceMappingURL=StableCoin__factory.js.map